module.exports = __webpack_public_path__ + "img/0Q3B3199_L_BlackMatted.93e81d0d.jpg";